/* 2026-10-19 (refine r3, Engagement Rings listing): metal dots on ring cards (snippets/product-card.liquid).
   A dot swaps the card photo to that metal's render, names the metal in the detail line and points the card's
   links at the ring page in that metal (?variant=). One listener on the document, so filtered and
   "load more" grids work without re-binding.
   2026-10-22 (inspo r1, item 3, after Frank Darling and VRAI): one metal for the whole wall. Ring listings get the
   four dots in the filter bar ("Metal", then the chosen metal's name); a choice presses that dot on every ring card,
   cards that Show more or a filter add later too, and is remembered for the visit (sessionStorage), so every ring
   listing and the ring page's More row open in it. The cards' own dots still work one by one. */
(function () {
  if (window.mgCardMetal) return;
  window.mgCardMetal = true;
  var KEY = 'mgWallMetal';
  var NAMES = { y: 'Yellow Gold', w: 'White Gold', r: 'Rose Gold', p: 'Platinum' };
  var ORDER = ['y', 'w', 'r', 'p'];

  function apply(card, b) {
    card.querySelectorAll('.mg-dots__b').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var img = card.querySelector('img.media--first');
    if (img && b.dataset.img) {
      if (b.dataset.srcset) img.setAttribute('srcset', b.dataset.srcset);
      img.setAttribute('src', b.dataset.img);
      // fix r2: the photo's description follows the metal ("... engagement ring in white gold")
      if (b.dataset.label && /(yellow gold|white gold|rose gold|platinum)$/i.test(img.alt)) img.alt = img.alt.replace(/(yellow gold|white gold|rose gold|platinum)$/i, b.dataset.label.toLowerCase());
    }
    var d = card.querySelector('.mg-card__detail--shape');
    if (d && b.dataset.label) {
      var m = d.querySelector('.mg-card__metal');
      if (!m) { m = document.createElement('span'); m.className = 'mg-card__metal'; d.appendChild(m); }
      m.textContent = ' · ' + b.dataset.label;
    }
    // fix r2 (2026-10-22): the link carries the metal only (?metal=), never a full ?variant=, so the ring opens in that
    // metal with nothing else chosen (owner: nothing preselected)
    var k = (/mg-dots__b--([ywrp])\b/.exec(b.className) || [])[1];
    if (b.dataset.url) card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.setAttribute('href', k ? b.dataset.url.split('?')[0] + '?metal=' + k : b.dataset.url); });
  }

  function saved() { try { return sessionStorage.getItem(KEY) || ''; } catch (err) { return ''; } }
  function save(k) { try { sessionStorage.setItem(KEY, k); } catch (err) { /* private mode: this page only */ } }
  function cards() {
    return document.querySelectorAll('#product-grid .mg-dots, [id$="__mg_pdp_more"] .mg-dots');
  }
  function wall(k) {
    if (!NAMES[k]) return;
    cards().forEach(function (dots) {
      var card = dots.closest('product-card') || dots.closest('.product-card');
      var b = dots.querySelector('.mg-dots__b--' + k);
      if (card && b && b.getAttribute('aria-pressed') !== 'true') apply(card, b);
    });
    document.querySelectorAll('.mg-wall').forEach(function (w) {
      w.querySelectorAll('.mg-wall__b').forEach(function (x) { x.setAttribute('aria-pressed', x.dataset.k === k ? 'true' : 'false'); });
      var n = w.querySelector('.mg-wall__name');
      if (n && n.textContent !== NAMES[k]) n.textContent = NAMES[k];
    });
  }

  // the bar's switch: ring listings only (a grid with at least two ring cards)
  function mount() {
    if (!document.body.classList.contains('template-collection')) return;
    var grid = document.getElementById('product-grid');
    var left = document.querySelector('.collection-top__container-left');
    if (!grid || !left || left.querySelector('.mg-wall') || grid.querySelectorAll('.mg-dots').length < 2) return;
    var w = document.createElement('div');
    w.className = 'mg-wall';
    w.setAttribute('role', 'group');
    w.setAttribute('aria-label', 'Show every ring in');
    var html = '<span class="mg-wall__label" aria-hidden="true">Metal</span>';
    ORDER.forEach(function (k) {
      html += '<button type="button" class="mg-dots__b mg-dots__b--' + k + ' mg-wall__b" data-k="' + k + '" aria-pressed="false" aria-label="' + NAMES[k] + '" title="' + NAMES[k] + '"><span class="mg-dots__d"></span></button>';
    });
    html += '<span class="mg-wall__name" aria-live="polite"></span>';
    w.innerHTML = html;
    left.appendChild(w);
    document.documentElement.classList.add('mg-has-wall');
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.mg-dots__b') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    if (b.classList.contains('mg-wall__b')) { save(b.dataset.k); wall(b.dataset.k); return; }
    var card = b.closest('product-card') || b.closest('.product-card');
    if (!card) return;
    apply(card, b);
  }, true);

  // first paint, then whatever Show more, a filter or the sort puts on the page
  var raf = 0;
  function refresh() {
    raf = 0;
    mount();
    var k = saved();
    if (k) wall(k);
  }
  function boot() {
    refresh();
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(refresh); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
